import { createHandoff } from '../../utils/handoff';
import { TargetsState } from './types';

// A worker invite prepared elsewhere (a Laila card) for the invite dialog to
// open with: the people and where they go, for the user to finish.
export interface WorkerInvitePrefill {
  // E.164, as the invite API takes them.
  phones: string[];
  targets: TargetsState;
}

export const workerInvitePrefill = createHandoff<WorkerInvitePrefill>();
